module.exports = __webpack_public_path__ + "static/media/angry-auctioneer.2185f13c.png";